import Progress from './progress';

export default Progress;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/smart/components/item/components/index.ts